import * as React from "react";
const SvgFiRrTrumpet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.614 3.072c-.805-.18-1.585.194-1.937.936-1.827 3.858-4.574 5.588-6.678 6.363V10a1 1 0 1 0-2 0v.9c-.571.092-.941.1-1.003.1H10v-1a1 1 0 1 0-2 0v1H6v-1a1 1 0 1 0-2 0v1H1a1 1 0 1 0 0 2h2.003A4.97 4.97 0 0 0 2 16c0 2.757 2.243 5 5 5h4a5.006 5.006 0 0 0 4.762-6.526c1.736 1.016 3.608 2.733 4.987 5.634.287.604.863.96 1.504.96q.195 0 .395-.045A1.72 1.72 0 0 0 24 19.342V4.79c0-.828-.57-1.535-1.386-1.72M14 16c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3s1.346-3 3-3c0 0 4.209-.008 4.311 0A3.02 3.02 0 0 1 14 16m8 2.177c-1.938-3.45-4.523-5.241-6.701-6.172 2.192-.93 4.789-2.723 6.701-6.192z"
    />
  </svg>
);
export default SvgFiRrTrumpet;
